export default __webpack_public_path__ + "static/media/drop.31add18f.svg";